import { Injectable } from '@angular/core';

import { OrderDetailsModel, OrderDetailsTransformer } from '../../../models';
import { IOrderDetailsHttpService } from '../../http';
import { IOrderDetailsService } from '../interfaces';

@Injectable()
export class OrderDetailsService implements IOrderDetailsService {
  private lastOrderDetails?: OrderDetailsModel;

  constructor(private orderDetailsHttpService: IOrderDetailsHttpService) {}

  async getOrderDetails(voucherCode: string, country: string): Promise<OrderDetailsModel> {
    const orderDetailsBack = await this.orderDetailsHttpService.getOrderDetails(voucherCode, country);
    const orderDetails = OrderDetailsTransformer.parse(orderDetailsBack);
    this.lastOrderDetails = orderDetails;
    return orderDetails;
  }

  getLastOrderDetails(): OrderDetailsModel | null {
    return this.lastOrderDetails ?? null;
  }
}
